import { Component, OnInit } from '@angular/core';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
    selector: 'app-sizzle-overlay',
    templateUrl: './sizzle-overlay.component.html',
    styleUrls: ['./sizzle-overlay.component.scss']
})
export class SizzleOverlayComponent implements OnInit {

    constructor(
        public pageDataService: PageDataService
    ) {

    }

    ngOnInit(): void {
    }

    onClose() {
        this.pageDataService.closeOverlay()
    }
}
